import cn from 'classnames'
import React, { FC } from 'react'

import styles from './HorizontalAssetsPreview.module.scss'

import Carousel from '~common/Carousel/Carousel'
import Button from '~elements/Button'
import LeftArrow from '~icons/arrowleft.svg'
import RightArrow from '~icons/arrowright.svg'

interface HorizontalAssetsPreviewProps {
  fullWidth?: boolean
  beforeChange?: (currentSlide: number, nextSlide: number) => void
  initialSlide?: number
  className?: string
  controlsClassName?: string
}

const HorizontalAssetsPreview: FC<React.PropsWithChildren<HorizontalAssetsPreviewProps>> = ({
  children,
  fullWidth,
  initialSlide,
  beforeChange,
  className,
  controlsClassName,
}) => {
  const hasChildren = React.Children.count(children) > 0

  return (
    <div className={cn(styles.root, !hasChildren && styles.hide, className)}>
      <Carousel
        initialSlide={initialSlide}
        onBeforeChange={beforeChange}
        className={cn(styles.inner, { [styles.fullWidth]: fullWidth })}
      >
        <Carousel.Content>
          {React.Children.map(children, (child) => (
            <Carousel.Item className={!fullWidth && styles.item}>{child}</Carousel.Item>
          ))}
        </Carousel.Content>

        <Carousel.Controls
          leftArrow={<Button icon={<LeftArrow />} />}
          rightArrow={<Button icon={<RightArrow />} />}
          className={controlsClassName}
        />
      </Carousel>
    </div>
  )
}

export default HorizontalAssetsPreview
